class CartRemoveButton extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('click', (event) => {
      event.preventDefault();
      const cartItems = this.closest('cart-items') || this.closest('cart-drawer-items');
      cartItems.updateQuantity(this.dataset.index, 0, event);
    });
  }
}

customElements.define('cart-remove-button', CartRemoveButton);

class CartItems extends HTMLElement {
  constructor() {
    super();
    this.lineItemStatusElement =
      document.getElementById('shopping-cart-line-item-status') || document.getElementById('CartDrawer-LineItemStatus');

    const debouncedOnChange = debounce((event) => {
      this.onChange(event);
    }, ON_CHANGE_DEBOUNCE_TIMER);

    this.addEventListener('change', debouncedOnChange.bind(this));
  }

  cartUpdateUnsubscriber = undefined;

  connectedCallback() {
    this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
      if (event.source === 'cart-items') {
        return;
      }
      return this.onCartUpdate();
    });
  }

  disconnectedCallback() {
    if (this.cartUpdateUnsubscriber) {
      this.cartUpdateUnsubscriber();
    }
  }

  resetQuantityInput(id) {
    const input = this.querySelector(`#Quantity-${id}`);
    input.value = input.getAttribute('value');
    this.isEnterPressed = false;
  }

  setValidity(event, index, message) {
    event.target.setCustomValidity(message);
    event.target.reportValidity();
    this.resetQuantityInput(index);
    event.target.select();
  }

  validateQuantity(event) {
    const inputValue = parseInt(event.target.value);
    const index = event.target.dataset.index;
    let message = '';

    if (inputValue < event.target.dataset.min) {
      message = window.quickOrderListStrings.min_error.replace('[min]', event.target.dataset.min);
    } else if (inputValue > parseInt(event.target.max)) {
      message = window.quickOrderListStrings.max_error.replace('[max]', event.target.max);
    } else if (inputValue % parseInt(event.target.step) !== 0) {
      message = window.quickOrderListStrings.step_error.replace('[step]', event.target.step);
    }

    if (message) {
      this.setValidity(event, index, message);
    } else {
      event.target.setCustomValidity('');
      event.target.reportValidity();
      this.updateQuantity(
        index,
        inputValue,
        event,
        document.activeElement.getAttribute('name'),
        event.target.dataset.quantityVariantId
      );
    }
  }

  onChange(event) {
    this.validateQuantity(event);
  }

  onCartUpdate(event) {
    if (this.tagName === 'CART-DRAWER-ITEMS') {
      return fetch(`${routes.cart_url}?section_id=cart-drawer`)
        .then((response) => response.text())
        .then((responseText) => {
          const html = new DOMParser().parseFromString(responseText, 'text/html');
          const selectors = ['cart-drawer-items', '.cart-drawer__footer'];
          for (const selector of selectors) {
            const targetElement = document.querySelector(selector);
            const sourceElement = html.querySelector(selector);
            if (targetElement && sourceElement) {
              targetElement.replaceWith(sourceElement);
            }
          }
          
          fetch(`${routes.cart_url}.js`)
            .then(response => response.json())
            .then(cartData => {
              updateFreeShippingProgress(cartData);
            })
            .catch(e => console.error('Error fetching cart data:', e));
          
          setTimeout(() => {
            initializeCartNoteTrigger();
          }, 100);

          if (event && event.openDrawer) {
            const cartDrawer = document.querySelector('cart-drawer');
            if (cartDrawer && typeof cartDrawer.open === 'function') {
              cartDrawer.open();
            }
          }
        })
        .catch((e) => {
          console.error(e);
        });
    } else {
      return fetch(`${routes.cart_url}?section_id=main-cart-items`)
        .then((response) => response.text())
        .then((responseText) => {
          const html = new DOMParser().parseFromString(responseText, 'text/html');
          const sourceQty = html.querySelector('cart-items');
          this.innerHTML = sourceQty.innerHTML;
        })
        .catch((e) => {
          console.error(e);
        });
    }
  }

  getSectionsToRender() {
    return [
      {
        id: 'main-cart-items',
        section: document.getElementById('main-cart-items').dataset.id,
        selector: '.js-contents',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
      {
        id: 'cart-live-region-text',
        section: 'cart-live-region-text',
        selector: '.shopify-section',
      },
      {
        id: 'main-cart-footer',
        section: document.getElementById('main-cart-footer').dataset.id,
        selector: '.js-contents',
      },
    ];
  }

  updateQuantity(line, quantity, event, name, variantId) {
    this.enableLoading(line);

    const body = JSON.stringify({
      line,
      quantity,
      sections: this.getSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname,
    });
    const eventTarget = event.currentTarget instanceof CartRemoveButton ? 'clear' : 'change';

    fetch(`${routes.cart_change_url}`, { ...fetchConfig(), ...{ body } })
      .then((response) => {
        return response.text();
      })
      .then((state) => {
        const parsedState = JSON.parse(state);

        CartPerformance.measure(`${eventTarget}:paint-updated-sections"`, () => {
          const quantityElement =
            document.getElementById(`Quantity-${line}`) || document.getElementById(`Drawer-quantity-${line}`);
          const items = document.querySelectorAll('.cart-item');

          if (parsedState.errors) {
            quantityElement.value = quantityElement.getAttribute('value');
            this.updateLiveRegions(line, parsedState.errors);
            return;
          }

          this.classList.toggle('is-empty', parsedState.item_count === 0);
          const cartDrawerWrapper = document.querySelector('cart-drawer');
          const cartFooter = document.getElementById('main-cart-footer');

          if (cartFooter) cartFooter.classList.toggle('is-empty', parsedState.item_count === 0);
          if (cartDrawerWrapper) cartDrawerWrapper.classList.toggle('is-empty', parsedState.item_count === 0);

          this.getSectionsToRender().forEach((section) => {
            const elementToReplace =
              document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);
            elementToReplace.innerHTML = this.getSectionInnerHTML(
              parsedState.sections[section.section],
              section.selector
            );
          });
          const updatedValue = parsedState.items[line - 1] ? parsedState.items[line - 1].quantity : undefined;
          let message = '';
          if (items.length === parsedState.items.length && updatedValue !== parseInt(quantityElement.value)) {
            if (typeof updatedValue === 'undefined') {
              message = window.cartStrings.error;
            } else {
              message = window.cartStrings.quantityError.replace('[quantity]', updatedValue);
            }
          }
          this.updateLiveRegions(line, message);

          const lineItem =
            document.getElementById(`CartItem-${line}`) || document.getElementById(`CartDrawer-Item-${line}`);
          if (lineItem && lineItem.querySelector(`[name="${name}"]`)) {
            cartDrawerWrapper
              ? trapFocus(cartDrawerWrapper, lineItem.querySelector(`[name="${name}"]`))
              : lineItem.querySelector(`[name="${name}"]`).focus();
          } else if (parsedState.item_count === 0 && cartDrawerWrapper) {
            trapFocus(cartDrawerWrapper.querySelector('.drawer__inner-empty'), cartDrawerWrapper.querySelector('a'));
          } else if (document.querySelector('.cart-item') && cartDrawerWrapper) {
            trapFocus(cartDrawerWrapper, document.querySelector('.cart-item__name'));
          }
        });

        CartPerformance.measureFromEvent(`${eventTarget}:user-action`, event);

        publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cart-items', cartData: parsedState, variantId: variantId });
        
        setTimeout(() => {
          updateFreeShippingProgress(parsedState);
        }, 100);
        
        setTimeout(() => {
          initializeCartNoteTrigger();
        }, 150);
      })
      .catch(() => {
        this.querySelectorAll('.loading__spinner').forEach((overlay) => overlay.classList.add('hidden'));
        const errors = document.getElementById('cart-errors') || document.getElementById('CartDrawer-CartErrors');
        errors.textContent = window.cartStrings.error;
      })
      .finally(() => {
        this.disableLoading(line);
      });
  }

  updateLiveRegions(line, message) {
    const lineItemError =
      document.getElementById(`Line-item-error-${line}`) || document.getElementById(`CartDrawer-LineItemError-${line}`);
    if (lineItemError) lineItemError.querySelector('.cart-item__error-text').textContent = message;

    this.lineItemStatusElement.setAttribute('aria-hidden', true);

    const cartStatus =
      document.getElementById('cart-live-region-text') || document.getElementById('CartDrawer-LiveRegionText');
    cartStatus.setAttribute('aria-hidden', false);

    setTimeout(() => {
      cartStatus.setAttribute('aria-hidden', true);
    }, 1000);
  }

  getSectionInnerHTML(html, selector) {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  enableLoading(line) {
    const mainCartItems = document.getElementById('main-cart-items') || document.getElementById('CartDrawer-CartItems');
    mainCartItems.classList.add('cart__items--disabled');

    const cartItemElements = this.querySelectorAll(`#CartItem-${line} .loading__spinner`);
    const cartDrawerItemElements = this.querySelectorAll(`#CartDrawer-Item-${line} .loading__spinner`);

    [...cartItemElements, ...cartDrawerItemElements].forEach((overlay) => overlay.classList.remove('hidden'));

    document.activeElement.blur();
    this.lineItemStatusElement.setAttribute('aria-hidden', false);
  }

  disableLoading(line) {
    const mainCartItems = document.getElementById('main-cart-items') || document.getElementById('CartDrawer-CartItems');
    mainCartItems.classList.remove('cart__items--disabled');

    const cartItemElements = this.querySelectorAll(`#CartItem-${line} .loading__spinner`);
    const cartDrawerItemElements = this.querySelectorAll(`#CartDrawer-Item-${line} .loading__spinner`);

    cartItemElements.forEach((overlay) => overlay.classList.add('hidden'));
    cartDrawerItemElements.forEach((overlay) => overlay.classList.add('hidden'));
  }
}

customElements.define('cart-items', CartItems);

if (!customElements.get('cart-note')) {
  customElements.define(
    'cart-note',
    class CartNote extends HTMLElement {
      constructor() {
        super();

        this.addEventListener(
          'input',
          debounce((event) => {
            const body = JSON.stringify({ note: event.target.value });
            fetch(`${routes.cart_update_url}`, { ...fetchConfig(), ...{ body } })
              .then(() => CartPerformance.measureFromEvent('note-update:user-action', event));
          }, ON_CHANGE_DEBOUNCE_TIMER)
        );
      }
    }
  );
}

function initializeCartNoteTrigger() {
  const cartNoteTrigger = document.querySelector('.cart-note-trigger');
  const cartNotePopup = document.querySelector('.cart-note-popup');
  
  if (cartNoteTrigger && cartNotePopup) {
    const newTrigger = cartNoteTrigger.cloneNode(true);
    cartNoteTrigger.parentNode.replaceChild(newTrigger, cartNoteTrigger);
    
    newTrigger.addEventListener('click', function(e) {
      e.preventDefault();
      e.stopPropagation();
      
      const isVisible = cartNotePopup.style.display !== 'none';
      
      if (isVisible) {
        cartNotePopup.style.opacity = '0';
        cartNotePopup.style.transform = 'translateY(-10px)';
        setTimeout(() => {
          cartNotePopup.style.display = 'none';
        }, 200);
      } else {
        cartNotePopup.style.display = 'block';
        cartNotePopup.offsetHeight;
        cartNotePopup.style.opacity = '1';
        cartNotePopup.style.transform = 'translateY(0)';
        
        const textarea = cartNotePopup.querySelector('textarea');
        if (textarea) {
          setTimeout(() => textarea.focus(), 300);
        }
      }
    });
  }
}

let cartNoteGlobalListenersInitialized = false;

function initializeCartNoteGlobalListeners() {
  if (cartNoteGlobalListenersInitialized) return;
  cartNoteGlobalListenersInitialized = true;
  
  document.addEventListener('click', function(e) {
    const cartNoteTrigger = document.querySelector('.cart-note-trigger');
    const cartNotePopup = document.querySelector('.cart-note-popup');
    
    if (cartNoteTrigger && cartNotePopup && 
        !cartNoteTrigger.contains(e.target) && !cartNotePopup.contains(e.target)) {
      if (cartNotePopup.style.display !== 'none') {
        cartNotePopup.style.opacity = '0';
        cartNotePopup.style.transform = 'translateY(-10px)';
        setTimeout(() => {
          cartNotePopup.style.display = 'none';
        }, 200);
      }
    }
  });
  
  document.addEventListener('keydown', function(e) {
    const cartNotePopup = document.querySelector('.cart-note-popup');
    if (e.key === 'Escape' && cartNotePopup && cartNotePopup.style.display !== 'none') {
      cartNotePopup.style.opacity = '0';
      cartNotePopup.style.transform = 'translateY(-10px)';
      setTimeout(() => {
        cartNotePopup.style.display = 'none';
      }, 200);
    }
  });
}

document.addEventListener('DOMContentLoaded', function() {
  initializeCartNoteTrigger();
  initializeCartNoteGlobalListeners();
});

function updateFreeShippingProgress(cartData) {
  const progressContainer = document.querySelector('.cart-drawer__free-shipping-progress');
  if (!progressContainer) return;

  const progressText = progressContainer.querySelector('.free-shipping-progress__text');
  
  if (progressText) {
    progressText.style.opacity = '0';
  }

  if (!cartData || typeof cartData.total_price !== 'number' || cartData.total_price < 0) {
    console.warn('Invalid cart data received:', cartData);
    if (progressText) {
      progressText.style.opacity = '1';
    }
    return;
  }

  const threshold = window.freeShippingThreshold || 10000;
  const cartTotal = cartData.total_price;
  
  if (typeof threshold !== 'number' || threshold <= 0) {
    console.warn('Invalid threshold value:', threshold);
    if (progressText) {
      progressText.style.opacity = '1';
    }
    return;
  }

  if (cartTotal > 999999999 || threshold > 999999999) {
    console.warn('Unreasonably large values detected:', { cartTotal, threshold });
    if (progressText) {
      progressText.style.opacity = '1';
    }
    return;
  }

  const remaining = Math.max(0, threshold - cartTotal);
  const progressPercentage = Math.min((cartTotal / threshold) * 100, 100);

  const progressFill = progressContainer.querySelector('.free-shipping-progress__fill');

  if (progressFill) {
    progressFill.style.width = progressPercentage + '%';
  }

  if (progressText) {
    if (remaining > 0) {
      const formattedAmount = new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD',
        minimumFractionDigits: 2
      }).format(remaining / 100);
      
      const message = window.freeShippingMessage || 'Add {amount} more for free shipping';
      progressText.textContent = message.replace('{amount}', formattedAmount);
      progressText.className = 'free-shipping-progress__text';
    } else {
      const successMessage = window.cartStrings?.freeShippingSuccess || window.freeShippingSuccessMessage || 'You\'ve qualified for free shipping!';
      progressText.textContent = successMessage;
      progressText.className = 'free-shipping-progress__text free-shipping-progress__text--success';
    }
    
    setTimeout(() => {
      progressText.style.opacity = '1';
    }, 150);
  }
}

document.addEventListener('DOMContentLoaded', function() {
  if (window.Shopify && window.Shopify.settings) {
    window.freeShippingThreshold = (window.Shopify.settings.free_shipping_threshold || 100) * 100;
    window.freeShippingMessage = window.Shopify.settings.free_shipping_message || 'Add {amount} more for free shipping';
    window.freeShippingSuccessMessage = window.Shopify.settings.free_shipping_success_message || 'You\'ve qualified for free shipping!';
  } else {
    window.freeShippingThreshold = 10000;
    window.freeShippingMessage = 'Add {amount} more for free shipping';
    window.freeShippingSuccessMessage = 'You\'ve qualified for free shipping!';
  }
  
  fetch(`${routes.cart_url}.js`)
    .then(response => response.json())
    .then(cartData => {
      updateFreeShippingProgress(cartData);
    })
    .catch(e => console.error('Error initializing progress bar:', e));
});

if (typeof subscribe !== 'undefined') {
  subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
    setTimeout(() => {
      initializeCartNoteTrigger();
    }, 200);
    if (event && event.openDrawer) {
      const cartDrawer = document.querySelector('cart-drawer');
      if (cartDrawer && typeof cartDrawer.open === 'function') {
        cartDrawer.open();
      }
    }
  });
}
